import PropTypes from 'prop-types';

const commonPropTypes = {
  cancellationReasons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  localisation: PropTypes.object.isRequired,
  isUpdatingAccount: PropTypes.bool.isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  adfitNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  recentNotClearedPayment: PropTypes.bool.isRequired,
  estimatedFinalBillDate: PropTypes.string,
  account: PropTypes.shape({
    outsideTerm: PropTypes.bool.isRequired,
    cancelFee: PropTypes.number.isRequired,
    overdueAmount: PropTypes.number.isRequired,
    facility: PropTypes.string.isRequired,
    isTermIdentified: PropTypes.bool.isRequired,
    hasPy: PropTypes.bool.isRequired,
  }).isRequired,
  balanceToSettleWithoutCancelFee: PropTypes.number,
  facility: PropTypes.shape({
    name: PropTypes.string,
    industryType: PropTypes.string.isRequired,
  }).isRequired,
  cancelDaysNotice: PropTypes.number.isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default commonPropTypes;
